// Kopie z FofrLamaPOS (components/pos/RamecPlatna.jsx) — editor stolů je v pokladně i ve Správě OS
// (Správa → Provozovna → Stoly, 2026-10-20). Měň obojí stejně.
import { ChevronLeft } from 'lucide-react'
import { COLORS, hexToRgba } from './sdilene'
import { KROK } from './usePretahovani'

/** Zaoblení rámečku. Štítek v rohu ho musí kopírovat, jinak by odstával. */
const RADIUS = 18

/**
 * Rámeček plátna — ohraničený blok s plochou pro souřadnice.
 *
 * Jméno sekce a cesta zpět sedí v **rohovém štítku zapuštěném do rámu**:
 * navazuje na jeho hranu, kopíruje zaoblení a nese barvu sekce, takže čte
 * jako součást bloku, ne jako tlačítko položené navrch. Hlavička přes celou
 * šířku tu byla předtím a nevyplatila se — ubírala plátnu výšku kvůli dvěma
 * prvkům, které se vejdou do rohu.
 *
 * Štítek je vysoký 48 px kvůli prstu a klikací je celý, ne jen ikona.
 * Zabírá levý horní roh plátna, kam se dlaždice rozvrhují nejmíň.
 *
 * Komponenta je společná pro provoz i editor schválně: plátno tak dostane
 * v obou přesně stejnou plochu a rozvržení sedí — kdyby se lišila o výšku
 * jednoho prvku, souřadnice by v každém vyšly jinam.
 */
export default function RamecPlatna({
  barva,
  nazev,
  onZpet,
  // Mřížka je editorová pomůcka na zarovnání; v provozu se nic nezarovnává.
  mrizka = false,
  meritkoX = 0,
  meritkoY = 0,
  refPlatna,
  children
}) {
  const tint = barva ?? COLORS.brand

  return (
    <div
      ref={refPlatna}
      className="sklo-panel w-full h-full relative overflow-hidden"
      style={{
        borderRadius: RADIUS,
        // Sklo jako dlaždice nabídky; barva sekce jen jako jemný nádech.
        ...(barva
          ? {
              borderColor: hexToRgba(barva, 0.5),
              background: `linear-gradient(160deg, ${hexToRgba(barva, 0.12)} 0%, rgba(255,255,255,0.025) 100%)`
            }
          : {}),
        ...(mrizka
          ? {
              backgroundImage:
                'linear-gradient(rgba(var(--tint-rgb),0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(var(--tint-rgb),0.05) 1px, transparent 1px)',
              backgroundSize: `${KROK * meritkoX}px ${KROK * meritkoY}px`
            }
          : {})
      }}
    >
      {children}

      {nazev && (
        <Stitek tint={tint} nazev={nazev} onZpet={onZpet} />
      )}
    </div>
  )
}

/**
 * Štítek v levém horním rohu plátna.
 *
 * Navazuje na rám: nahoře a vlevo žádná vlastní linka (splývá s rámečkem),
 * vpravo a dole ano — tím vznikne dojem vyříznutého rohu, ne nalepeného
 * tlačítka. Podklad je neprůhledný, aby přes něj neprosvítala dlaždice.
 */
function Stitek({ tint, nazev, onZpet }) {
  const Obal = onZpet ? 'button' : 'div'

  return (
    <Obal
      onClick={onZpet || undefined}
      className="absolute flex items-center gap-2 pl-3.5 pr-4"
      style={{
        left: 0,
        top: 0,
        height: 48,
        borderTopLeftRadius: RADIUS - 1,
        borderBottomRightRadius: 16,
        background: 'rgba(22,22,28,0.78)',
        backdropFilter: 'blur(12px)',
        borderRight: `1px solid ${hexToRgba(tint, 0.45)}`,
        borderBottom: `1px solid ${hexToRgba(tint, 0.45)}`,
        color: tint,
        cursor: onZpet ? 'pointer' : 'default',
        zIndex: 5
      }}
    >
      {onZpet && <ChevronLeft size={18} style={{ opacity: 0.7 }} />}
      <span className="text-[15px] font-bold" style={{ letterSpacing: -0.2 }}>
        {nazev}
      </span>
    </Obal>
  )
}
